export function range(n) {
  return Array.from({
    length: n
  }, function (_, i) {
    return i;
  });
}
export function formatArray(arr) {
  return "[".concat(arr.map(function (item) {
    return "\"".concat(item, "\"");
  }).join(", "), "]");
}